import { createAction } from 'redux-actions'

export const APPEND_LOG = 'APPEND_LOG'
const OPEN_WSS = 'OPEN_WSS'
const TRY_CLOSING_WSS = 'TRY_CLOSING_WSS'

export const WSS_ENDPOINT_FETCH = 'WSS_ENDPOINT_FETCH'
export const WSS_ENDPOINT_FETCH_INTEGRATION = 'WSS_ENDPOINT_FETCH_INTEGRATION'
export const WSS_ENDPOINT_FETCH_FULFILLED = 'WSS_ENDPOINT_FETCH_FULFILLED'
export const WSS_ENDPOINT_FETCH_CANCEL = 'WSS_ENDPOINT_FETCH_CANCEL'
export const WSS_ENDPOINT_FETCH_REJECTED = 'WSS_ENDPOINT_FETCH_REJECTED'
const WSS_CLOSED = 'WSS_CLOSED'
const SEND_WSS_MESSAGE = 'SEND_WSS_MESSAGE'
const PARSE_WSS_MESSAGE = 'PARSE_WSS_MESSAGE'

export const wssOpened = createAction(OPEN_WSS)
export const tryClosingWss = createAction(TRY_CLOSING_WSS)

export const wssEndpointFetch = createAction(WSS_ENDPOINT_FETCH)
export const wssEndpointFetchIntegration = createAction(WSS_ENDPOINT_FETCH_INTEGRATION)
export const wssEndpointFetchFulfilled = createAction(WSS_ENDPOINT_FETCH_FULFILLED)
export const wssEndpointFetchCancel = createAction(WSS_ENDPOINT_FETCH_CANCEL)
export const wssEndpointFetchRejected = createAction(WSS_ENDPOINT_FETCH_REJECTED)
export const wssClosed = createAction(WSS_CLOSED)
export const sendWssMessage = createAction(SEND_WSS_MESSAGE)
export const parseWssMessage = createAction(PARSE_WSS_MESSAGE)
